/*
  Horelya — choix 1 flacon / Duo / Trio sur la fiche parfum (snippet horelya-lots.liquid).

  Principe : on réutilise le formulaire produit natif de Dawn, sans le dupliquer.
  - Les menus et le champ « Parfum 1 » sont rattachés au formulaire via l'attribut HTML « form ».
  - Choisir Duo ou Trio remplace l'identifiant de variante du formulaire par celui du coffret
    et active les menus correspondants (un champ désactivé n'est jamais envoyé).
  - Revenir à « 1 flacon » restaure l'état d'origine.
  - Le formulaire de Dawn est en « novalidate » : on vérifie donc nous-mêmes que chaque parfum est choisi,
    en capture sur <product-info>, avant que Dawn n'envoie le panier.
*/
if (!customElements.get('horelya-lots')) {
  class HorelyaLots extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.form = this.productInfo && this.productInfo.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form) return;

      this.variantInput = this.form.querySelector('input[name="id"]');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.submitLabel = this.submitButton && this.submitButton.querySelector('span');
      this.paymentButton = this.form.querySelector('.shopify-payment-button');
      this.firstPick = this.querySelector('[data-first-pick]');
      this.errorBox = this.querySelector('[data-error]');
      this.defaults = {
        variantId: this.variantInput.value,
        label: this.submitLabel ? this.submitLabel.textContent : '',
      };

      this.querySelectorAll('select, [data-first-pick]').forEach((field) => field.setAttribute('form', this.form.id));

      this.onChange = this.onChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.addEventListener('change', this.onChange);
      this.productInfo.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      if (this.productInfo) this.productInfo.removeEventListener('submit', this.onSubmit, true);
    }

    get selected() {
      return this.querySelector('input[type="radio"]:checked');
    }

    onChange(event) {
      if (event.target.type === 'radio') this.apply(event.target);
      if (event.target.tagName === 'SELECT') this.showError('');
    }

    apply(radio) {
      const isLot = radio.value !== 'single';

      this.querySelectorAll('[data-picks]').forEach((panel) => {
        const active = panel.dataset.picks === radio.value;
        panel.hidden = !active;
        panel.querySelectorAll('select').forEach((select) => (select.disabled = !active));
      });

      this.firstPick.disabled = !isLot;
      this.variantInput.value = isLot ? radio.dataset.variantId : this.defaults.variantId;
      if (this.submitLabel) this.submitLabel.textContent = isLot ? radio.dataset.cta : this.defaults.label;
      if (this.paymentButton) this.paymentButton.hidden = isLot;
      this.showError('');
    }

    onSubmit(event) {
      if (event.target !== this.form || !this.selected || this.selected.value === 'single') return;

      const missing = Array.from(this.querySelectorAll('[data-picks]:not([hidden]) select')).find((s) => !s.value);
      if (!missing) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError('Choisissez chaque parfum de votre coffret.');
      missing.focus();
    }

    showError(message) {
      if (this.errorBox) this.errorBox.textContent = message;
    }
  }

  customElements.define('horelya-lots', HorelyaLots);
}
